import {loadFavoritesFromLocalStorage}  from './utils/functions.js';



document.addEventListener('DOMContentLoaded', () => {
loadFavoritesFromLocalStorage();

});